import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  margin: 0;
  overflow: hidden;
  display: flex;
  font-size: 1rem;
`;

export const ResetPassword = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  max-width: 40vw;

  form {
    width: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 3.88rem 6.16rem 0 6.16rem;
    max-width: 100%;
    align-items: stretch;
    text-align: flex-start;

    > svg {
      margin: 0 0 8%;
    }

    > h1 {
      font-family: 'RedHatDisplay-Bold';
      font-size: 1.339rem;
      margin-bottom: 2.22rem;
    }

    > span {
      display: flex;
      justify-content: flex-start;
      font-family: 'RedHatDisplay-Regular';
      font-size: 0.88rem;
      text-align: left;
      margin-top: 8.33%;
      margin-bottom: 1.5%;
    }

    > .primary-button {
      margin-top: 1.44rem;
      margin-bottom: 0.88rem;
      height: 3.33rem;
      font-family: 'RedHatDisplay-ExtraBold';
      font-size: 1.11rem;
      border-radius: 0.55rem;
      box-shadow: 0px 3px 15px rgba(255, 152, 0, 0.3);
    }
  }
  footer {
    width: 100%;
    height: 0.778rem;
    background-color: #ff9800;
  }
  @media (max-width: 810px) {
    max-width: 100vw;
  }
`;

export const ImageArea = styled.main`
  position: relative;
  width: 100%;
  img {
    width: 100%;
    height: 101vh;
    object-fit: cover;
    object-position: center;
  }
`;

export const TipBackground = styled.div`
  position: absolute;
  z-index: 1000;
  bottom: 3.16rem;
  right: 3.94rem;
  width: 22.94rem;
  height: 12.83rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    object-position: center;
  }
`;

export const Footer = styled.div`
  flex: 1;
  align-items: flex-end;
  width: 100%;
  height: auto;
`;

export const SideContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 100vh !important;

  @media (max-width: 810px) {
    display: none;
  }
`;

export const BackToLogin = styled.div`
  width: 31.67rem;
  border-top: 1px solid #e2e2e2;
  margin-bottom: 3.88rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin-bottom: 0.778rem;
    margin-top: 1.89rem;
  }

  > .secondary-button {
    font-family: 'RedHatDisplay-ExtraBold';

    text-align: center !important;
    font-size: 1rem;
    color: #1e88e5;
    line-height: 1.28rem;
    padding: 0.77rem 0.72rem 0.77rem 0.88rem;
    border: 1px solid #1e88e5;
    border-radius: 0.55rem;

    width: 100%;
  }
`;
export const TopContent = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LanguageButtons = styled.div`
  position: absolute;
  z-index: 1000;
  display: flex;
  top: 3.16rem;
  left: 3.94rem;
  align-items: center;
  color: #ffffff80;

  > button {
    background: none;
    border: 0;
    font-family: 'RedHatDisplay-Regular';
    font-size: 1.22rem;
    color: #ffffff80;

    &.active-language {
      color: #fff;
    }
  }

  > button:first-child {
    margin-right: 0.33rem;
  }

  > button:last-child {
    margin-left: 0.33rem;
  }
`;
